import styles from './Icons.module.css';
import { ReactComponent as Twitter } from 'assets/social-links/twitter.svg';

export const TwitterIcon = () => (
    <div className={styles['icon']}>
        <Twitter />
    </div>
);
